module.exports = __webpack_public_path__ + "static/img/findingHome.dccc1f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/posters/findingHome.jpg
// module id = 45
// module chunks = 0